import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 25", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.501, d: "M16.606 21.758h4.606V5.636L18.91 3.333l-2.303 2.303v16.121zM16.606 17.151h4.606M13.842 3.333H2.788v18.425h11.054" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.501, d: "M6.473 7.018h6.909v3.685h-6.91V7.018z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
